import { StorySlug } from "@/api/episodes-types";

export function pretty(
  string: string,
  splitMethod: "capitalLetters" | "underscores" | "dashes" = "underscores",
) {
  const words =
    splitMethod === "capitalLetters"
      ? string.split(/(?=[A-Z])/)
      : splitMethod === "underscores"
        ? string.split("_")
        : string.split("-");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function prettyStoryType(storyType: StorySlug) {
  switch (storyType) {
    case StorySlug.pete_the_cat:
      return "Pete the Cat";
    default:
      return pretty(storyType);
  }
}

export function prettyId(id: string | undefined): string {
  return id ? `${id.slice(0, 4)}...${id.slice(-2)}` : "";
}
